import { render, staticRenderFns } from "./AccentTitleCard.vue?vue&type=template&id=6521217a"
import script from "./AccentTitleCard.vue?vue&type=script&lang=js"
export * from "./AccentTitleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports